// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"FVOWO7jz","title":"GEu5snqQ","small":"ndRR7ysl","withTextDecoration":"nKPyY83a","styledLink":"LgSVCcVT"};